import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

// one disabled fieldset locks every control at once, incl. the custom non-input ones the forms are built from
const ReadOnlyFields = ({ classes, active, children }) =>
  active ? (
    <fieldset className={classes.fieldset} disabled>
      {children}
    </fieldset>
  ) : (
    <>{children}</>
  );

export default withStyles(styles)(ReadOnlyFields);
